import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {RateCardModel} from '../../../models/RateCardModel';
import {RateCardService} from './service-rate-card/rate-card.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-rate-card',
  templateUrl: './rate-card.component.html',
  styleUrls: ['./rate-card.component.scss']
})
export class RateCardComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isRateCardSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: RateCardModel;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private rateCardService: RateCardService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    // this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new RateCardModel();
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isRateCardSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    if (this.showActions === true) {

      this.displayedColumns = ['regionDesc', 'currencyDesc', 'rolesDesc', 'rateTypeDesc',  'transition_OS',
        'onSite_FTS', 'hours', 'year1', 'year1Ammount', 'year2', 'year2Ammount', 'year3', 'year3Ammount', 'actions'];
    } else {

      this.displayedColumns = ['regionDesc', 'currencyDesc', 'roleDesc', 'rateTypeDesc', 'transition_OS',
        'onSite_FTS', 'hours', 'year1', 'year1Ammount', 'year2', 'year2Ammount', 'year3', 'year3Ammount'];
    }

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.RATE_CARD_OFFSET);
    this.getSessionStorageFilter();
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  init() {
    if (!this.reportSection) {
      this.showFilter = false;
      this.getDataPage(this.offset, this.filter);
    } else {
      this.showFilter = true;
    }
    this.loaderService.display(false);
  }


  getDataPage(offset: Offset, filter: RateCardModel) {
    this.getPageSubscribe = this.rateCardService.getPage(offset, filter)
      .subscribe(
        (rFinal: any) => {
          this.dataSource = rFinal.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = rFinal.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const rateCardData = this.dataSource.find(data => data.id === id) as RateCardModel, list: GenericArray[] = [
      {id: 'Region Cod', value: this.toCustomString(rateCardData.region.cod)},
      {id: 'Region Description', value: this.toCustomString(rateCardData.region.description)},
      {id: 'Currency Cod', value: this.toCustomString(rateCardData.currency.cod)},
      {id: 'Currency Description', value: this.toCustomString(rateCardData.currency.description)},
      {id: 'Role Cod', value: this.toCustomString(rateCardData.roles.code)},
      {id: 'Role Description', value: this.toCustomString(rateCardData.roles.description)},
      {id: 'Rate Type Cod', value: this.toCustomString(rateCardData.rateType.code)},
      {id: 'Rate Type Description', value: this.toCustomString(rateCardData.rateType.description)},
      {id: 'Transition OS', value: this.toCustomString(rateCardData.transitionOs)},
      {id: 'Onsite FTS', value: this.toCustomString(rateCardData.onsiteFts)},
      {id: 'Hours', value: this.toCustomString(rateCardData.hours)},
      {id: 'Year 1', value: this.toCustomString(rateCardData.year1)},
      {id: 'Year 1 amount', value: this.toCustomString(rateCardData.year1Ammount)},
      {id: 'Year 2', value: this.toCustomString(rateCardData.year2)},
      {id: 'Year 2 amount', value: this.toCustomString(rateCardData.year2Ammount)},
      {id: 'Year 3', value: this.toCustomString(rateCardData.year3)},
      {id: 'Year 3 amount', value: this.toCustomString(rateCardData.year3Ammount)},
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.RATE_CARD_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }


  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.loaderService.display(true);
      this.deleteElementSubscribe = this.rateCardService.softDelete(id)
        .subscribe(
          (result: any) => {
            toastr.success('Rate card with id ' + id + ' was deleted with success', 'Success');
            this.getDataPage(this.offset, this.filter);
          }, error =>  {
            this.loaderService.display(false);
            toastr.error('Rate card with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  showNewMassive() {
    let showNewMassive = false;
    if (this.canInsert) {
      showNewMassive = true;
    }
    if (this.reportSection) {
      showNewMassive = false;
    }
    return showNewMassive;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.RATE_CARD_FILTER));
    this.filter = filter_ ? filter_ : new RateCardModel();
  }
}
